import { memo, useEffect, useMemo, useState } from 'react';
import { Flex, Modal, Typography } from 'antd';
import { FormikProps } from 'formik';
import { MButton, MSelect, MTextArea } from '@Components/Base';
import { useGetEmployeeITAdminsQuery } from '@Store/api/userApiSlice';
import { Option } from '@Components/types/options';

import styles from './style-notification.module.css';

import { initFormikValuesType } from './types';

interface ITAdminNotificationProps {
  title: string;
  textSuccessBtn: string;
  isModalOpen: boolean;
  formik: FormikProps<initFormikValuesType>;
  compId: number;
  message?: string;
  handleSuccess: () => void;
  handleCancel: () => void;
  textCancelBtn?: string;
}

const ITAdminNotification: React.FC<ITAdminNotificationProps> = ({
  title,
  isModalOpen,
  textSuccessBtn,
  textCancelBtn = 'No, Thanks',
  formik,
  handleSuccess,
  handleCancel,
  message,
  compId,
}) => {
  const { data } = useGetEmployeeITAdminsQuery(compId);
  const [userOptions, setUserOptions] = useState<Array<Option>>([]);

  useEffect(() => {
    if (data) {
      const transformedUsers = data.map((user) => ({
        label: `${user.empName} | ${user.empNumber}`,
        value: String(user.userId),
      }));

      setUserOptions(transformedUsers);
    }
  }, [data]);

  const customButtons = useMemo(() => {
    return [
      <MButton key="back" id="cancel" type="tertiary" onClick={handleCancel}>
        {textCancelBtn}
      </MButton>,
      <MButton key="submit" id="ok" type="primary" onClick={handleSuccess}>
        {textSuccessBtn}
      </MButton>,
    ];
  }, [textCancelBtn, textSuccessBtn, handleSuccess, handleCancel]);

  const isReject = title === 'Reject Request';

  return (
    <Modal
      open={isModalOpen}
      onOk={handleSuccess}
      onCancel={handleCancel}
      className={styles.modal}
      footer={customButtons}
      closeIcon={false}
      maskClosable={false}
    >
      <Flex vertical>
        <Flex className={styles.titleSection}>
          <Typography.Text className={styles.title}>{title}</Typography.Text>
        </Flex>
        {message && <div className={styles.messageSection}>{message}</div>}
        <div className={styles.fieldsSection}>
          {!isReject && (
            <div>
              <Typography.Text>
                Please choose the respective IT Admin:
              </Typography.Text>
              <MSelect
                className={styles.select}
                options={userOptions}
                onChange={(value) => {
                  formik.setFieldValue('itAdmin', String(value));
                }}
                placeholder="Choose IT Admin"
              />
            </div>
          )}
          {!isReject && (
            <div>
              <Typography.Text>Comments:</Typography.Text>
              <MTextArea
                name="comments"
                onChange={(input) =>
                  formik.setFieldValue('comment', input.target.value)
                }
                rows={4}
                showCount
                maxLength={100}
                placeholder="Enter your comments (if any)..."
              />
            </div>
          )}
        </div>
      </Flex>
    </Modal>
  );
};

export default memo(ITAdminNotification);
